import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { KibTopLevelAlert } from '@chewy/kib-messaging-react'

import '@chewy/kib-messaging-styles/dist/styles/kib-alert-icon.css'
import '@chewy/kib-messaging-styles/dist/styles/kib-top-level-alert.css'
import styles from './SwapProductSuccessToast.module.scss'

interface SwapProductSuccessToastProps {
  onClose: () => void
  open: boolean
}

const SwapProductSuccessToast: FC<SwapProductSuccessToastProps> = ({
  open,
  onClose,
}) => {
  const { t } = useTranslation(['Common', 'Dialogs'])

  if (!open) {
    return null
  }

  return (
    <KibTopLevelAlert
      dismissible
      className={styles.container}
      heading={t('Common:SWAP_PRODUCT_SUCCESS_MESSAGE')}
      severity="success"
      onDismiss={onClose}
    />
  )
}

export default SwapProductSuccessToast
